var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voice",class:{ 'self-voice': _vm.isSelf },style:({ width: _vm.voiceWidth + 'px' }),on:{"click":function($event){return _vm.play()}}},[_c('i',{staticClass:"iconfont icon-voice",class:{ playing: _vm.playing }}),_c('span',[_vm._v(_vm._s(_vm.length)+"\"")])])
}
var staticRenderFns = []

export { render, staticRenderFns }